import React from 'react'

function UmbrellaIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.841 5.305a21.708 21.708 0 0 0-1.835-.071 29.212 29.212 0 0 0-1.863.072 3.41 3.41 0 0 0-.407.047 11.282 11.282 0 0 0-8.786 8.782c.826-.39 1.813-.608 2.853-.608 1.623 0 3.141.536 4.1 1.444a4.05 4.05 0 0 1 .825-.616l.084-.047c.972-.607 2.082-.78 3.188-.78 1.106 0 2.216.173 3.189.78l.082.047h.001c.301.17.578.377.825.615.958-.91 2.478-1.443 4.1-1.443 1.038 0 2.023.219 2.848.61a11.283 11.283 0 0 0-8.793-8.774 3.407 3.407 0 0 0-.41-.058Zm-1.2 9.527c.716.06 1.343.23 1.878.567l.025.015.096.055h.002c.37.21.688.5.93.85a.64.64 0 0 0 1.062-.013c.534-.815 1.865-1.499 3.563-1.499 1.402 0 2.576.476 3.235 1.123a.64.64 0 0 0 1.086-.507 12.562 12.562 0 0 0-10.01-11.315 4.686 4.686 0 0 0-.566-.079 22.969 22.969 0 0 0-1.948-.075 30.55 30.55 0 0 0-1.928.075 4.687 4.687 0 0 0-.577.068 12.562 12.562 0 0 0-10.01 11.315.64.64 0 0 0 1.083.51c.662-.642 1.839-1.115 3.241-1.115 1.697 0 3.03.687 3.564 1.5a.64.64 0 0 0 1.062.012 2.8 2.8 0 0 1 .929-.85h.002l.097-.055a.54.54 0 0 0 .024-.015c.535-.337 1.162-.507 1.88-.567v11.169c0 1.197-.965 2.026-2.361 2.026-.694 0-1.278-.214-1.679-.56-.392-.338-.641-.827-.641-1.466a.64.64 0 0 0-1.28 0c0 1.007.408 1.851 1.085 2.435.668.576 1.564.871 2.515.871 1.894 0 3.64-1.21 3.64-3.306V14.832Z"
        fill="url(#a)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 2.797a.64.64 0 0 1 .64.64v1.148a.64.64 0 0 1-1.28 0V3.437a.64.64 0 0 1 .64-.64Z"
        fill="url(#b)"
      />
      <defs>
        <radialGradient
          id="a"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(-134.52 24.937 10.681) scale(52.2015 177.555)"
        >
          <stop stopColor="#E60000" />
          <stop offset={1} stopColor="#9C2AA0" />
        </radialGradient>
        <radialGradient
          id="b"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(-117.689 10.253 -2.196) scale(4.02588 11.2703)"
        >
          <stop stopColor="#E60000" />
          <stop offset={1} stopColor="#9C2AA0" />
        </radialGradient>
      </defs>
    </svg>

  )
}

export default UmbrellaIcon